function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React from "react";
import "./ButtonIcon.css"; // #region FONCTION COMPOSANT

/**
 * Un composant représentant un bouton avec une icône provenant de Font Awesome
 * @class
 * @category Fields
 * @param {ButtonIcon.propTypes} props
 */

function ButtonIcon(props) {
  var icon = props.icon,
      onClick = props.onClick,
      style = props.style,
      tooltip = props.tooltip;
  return /*#__PURE__*/React.createElement("div", {
    className: "ButtonIcon-Container",
    onClick: onClick,
    style: _extends({}, style)
  }, /*#__PURE__*/React.createElement("i", {
    className: "ButtonIcon-Icon fas fa-" + icon,
    "data-tip": tooltip,
    "data-for": "DefaultTooltip"
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link ButtonIcon}
 * @typedef {Object} ButtonIcon.propTypes
 * @property {string} icon Le nom de l'icône (rechercher sur fontawesome.com)
 * @property {function} onClick La fonction appelée lors du clic sur le bouton
 * @property {object} style Style à appliquer au composant
 * @property {string} tooltip Tooltip à afficher au survol
 */


ButtonIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  tooltip: PropTypes.string
} : {};
ButtonIcon.defaultProps = {
  style: {},
  tooltip: null
}; // #endregion

export { ButtonIcon };